import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from '@material-ui/core';
import styles from './styles.css';

export default class Footer extends Component {
    handleScrollTop() {
        window.scroll({top: 0, left: 0, behavior: 'smooth'});
    }

    render() {
        return (
            <div className={styles.root}>
                <Grid container className={styles.container} justify='space-between' alignItems='center'>
                    <Grid item>
                        <Link
                            className={styles.logo}
                            to='http://www.niderasemillas.com.ar'
                            target='_blank'
                            rel='noopener noreferrer'
                        />
                    </Grid>
                    <Grid item className={styles.info}>
                        <div className={styles.contact}>
                            <div className={styles.socialMedia}>
                                <a
                                    href='https://es-la.facebook.com/NideraSemillas/'
                                    target='_blank'
                                    rel='noopener noreferrer'>
                                    <i className={styles.icon}><div className={styles.fb} /></i>
                                </a>
                            </div>
                            <div className={styles.socialMedia}>
                                <a
                                    href='https://twitter.com/niderasemillas'
                                    target='_blank'
                                    rel='noopener noreferrer'>
                                    <i className={styles.icon}><div className={styles.tw} /></i>
                                </a>
                            </div>
                            <div className={styles.socialMedia}>
                                <a
                                    href='https://instagram.com/niderasemillas'
                                    target='_blank'
                                    rel='noopener noreferrer'>
                                    <i className={styles.icon}><div className={styles.ig} /></i>
                                </a>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <p className={styles.version}>Versión {CONFIG.version}</p>
                    </Grid>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/footer/index.js